import { Box, Center, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import * as _ from 'lodash';
import React, { useCallback } from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone';

import { colors } from 'packages/common-frontend/colors';
import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

type Props = {
  isDisabled: boolean;
  setFieldValue: (value: FileWithPath) => void;
  accept: any;
};
export const UploadScreenshotFormField = ({
  isDisabled,
  setFieldValue,
  accept,
}: Props) => {
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept,
    multiple: false,
    onDrop: useCallback((files: FileWithPath[]) => setFieldValue(files[0]), [
      setFieldValue,
    ]),
    disabled: isDisabled,
  });

  const fileSelected = !_.isEmpty(acceptedFiles) || !_.isEmpty(fileRejections);
  const bgColor = useColorModeValue(colors.background[50], 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.200');

  return (
    <Box width="100%" cursor="pointer">
      <Center
        border="1px"
        borderColor="gray.100"
        borderRadius="md"
        bgColor={bgColor}
        minHeight="250px"
        flexDirection="column"
        {...getRootProps({ className: 'dropzone' })}
      >
        <input {...getInputProps()} />
        {!_.isEmpty(acceptedFiles) && (
          <Stack alignItems="center">
            <FaIcon icon="circle-check" color="green.300" boxSize={10} />
            <Text color={textColor} pt={4} fontWeight="semibold" fontSize="xl">
              Upload successful
            </Text>
          </Stack>
        )}
        {!_.isEmpty(fileRejections) && (
          <Stack alignItems="center">
            <FaIcon icon="circle-xmark" color="red.300" boxSize={10} />
            <Text color={textColor} pt={4} fontWeight="semibold" fontSize="xl">
              Upload failed
            </Text>
            <Text color={textColor} fontSize="sm">
              Try again
            </Text>
          </Stack>
        )}
        {!fileSelected && (
          <Stack alignItems="center">
            <FaIcon icon="file-arrow-up" color="gray.400" boxSize={10} />
            <Text color={textColor} pt={4} fontWeight="semibold" fontSize="xl">
              Drop a file to upload
            </Text>
            <Text color={textColor} fontSize="sm">
              or browse here
            </Text>
          </Stack>
        )}
      </Center>
    </Box>
  );
};
